import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetProduktionsdatumCommand extends BasicCommand<SetProduktionsdatumCommand> {
    get primaryKey(): IPrimaryKey<SetProduktionsdatumCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    startdatum?: string;
    slutdatum?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetProduktionsdatumCommand";
    constructor(init: (instance: SetProduktionsdatumCommand) => void) {
        super(SetProduktionsdatumCommand.$type, SetProduktionsdatumCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
